const Assets = {
  AuthImage: require('../assets/img/auth-img.png'),
  LogoImage: require('../assets/img/logo.png'),
  DashboardLogo: require('../assets/img/dashboard-logo.png'),
  ProfileUserImage: require('../assets/img/profile-user.png'),
  GeneralPlaceholder: require('../assets/img/general-placeholder.png'),
  ProfilePlaceholder: require('../assets/img/profile-placeholder.png'),

  UserImg: require('../assets/img/user-img.png'),
  CompanyImg: require('../assets/img/company-img.png'),
  AdminImg: require('../assets/img/admin-img.png'),
  GroupAddedImg: require('../assets/img/group-added.png'),
  GroupCreatedImg: require('../assets/img/group-created.png'),
  ThreadCreatedImg: require('../assets/img/thread-created.png'),
  GroupImg: require('../assets/img/group-img.png'),
  SendImg: require('../assets/img/send-img.png'),

  UserImg1: require('../assets/img/user-1.png'),
  UserImg2: require('../assets/img/user-2.png'),
  UserImg3: require('../assets/img/user-3.png'),
  UserImgLg: require('../assets/img/user-lg.jpg'),

  BlockImg: require('../assets/img/block.png'),
  EditImg: require('../assets/img/edit.png'),
  DeleteImg: require('../assets/img/delete-img.png'),
  EyeImg: require('../assets/img/eye.png'),
  DownloadImg: require('../assets/img/download.png'),
  ShareImg: require('../assets/img/share-img.png'),
  ArrowBack: require('../assets/img/arrow-back.png'),
  WarningImg: require('../assets/img/warning.png'),

  DashboardImg: require('../assets/img/dashboard-img.png'),
  UserManagementImg: require('../assets/img/user-management-img.png'),
  ReportManagementImg: require('../assets/img/report-management-img.png'),
  CompanyManagementImg: require('../assets/img/company-management-img.png'),
  ContactSupportImg: require('../assets/img/contact-support-img.png'),
  SettingImg: require('../assets/img/setting-img.png'),
  CheckCircle: require('../assets/img/check-circle.png'),
  NotFound: require('../assets/img/not-found.jpg'),
  UploadImg: require('../assets/img/upload-img.png'),
};

export default Assets;
